import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Panduan from './components/Panduan';
import Mekanisme from './components/Mekanisme';
import Artikel from './components/Artikel';
import Faq from './components/Faq';
import Laporan from './components/Laporan';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Hero />
                <Panduan />
                <Mekanisme />
                <Artikel />
                <Faq />
              </>
            }
          />
          <Route path="/laporan" element={<Laporan />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
